module.exports = __webpack_public_path__ + "static/img/goods_detail.7cb259e.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/common/img/goods_detail.png
// module id = 2y9k
// module chunks = 37